import { STAGE_COLOR, type PipelineStage } from "@/lib/enums";

export function StageBadge({ stage }: { stage: string }) {
  const color = STAGE_COLOR[stage as PipelineStage] ?? "var(--ash)";
  return (
    <span className="badge" style={{ color }}>
      <span className="dot" />
      {stage}
    </span>
  );
}

export function StatusBadge({ status }: { status: string }) {
  const tone =
    status === "RELEASED" || status === "MASTERED" || status === "READY" || status === "FINAL" || status === "DONE"
      ? "var(--gold)"
      : status === "PENDING" || status === "DRAFT"
        ? "var(--ash)"
        : "var(--molten)";
  return (
    <span className="badge" style={{ color: tone }}>
      <span className="dot" />
      {status}
    </span>
  );
}

export function RemixBadge() {
  return <span className="badge badge-remix">REMIX</span>;
}
